<template>
  <div class="filters__selected d-flex justify-content-end flex-wrap">
    <div class="d-flex justify-content-lg-end flex-wrap filters__selected-list">
      <ActiveFilterButton
        v-for="(filter) in activeArtworksFiltersArray"
        :key="filter.name"
        :filter="filter"
      />
    </div>
    <button
      v-if="anyArtworksFilterActive"
      @click="clearFilters()"
      type="button"
      :title="I18n.t('filters.remove_all_title')"
      class="btn-link filters__remove-all change-margins"
    >
      <span class="icon icon-close-big"></span>
      {{ I18n.t("filters.clear_filters") }}
    </button>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import ActiveFilterButton from './button';


  export default {
    name: 'ActiveFiltersList',
    components: {
      ActiveFilterButton,
    },
    computed: {
      ...mapGetters(['anyArtworksFilterActive', 'activeArtworksFiltersArray']),
    },
    methods: {
      ...mapActions(['getArtworksWhenFiltersAreCleared']),
      clearFilters() {
        this.getArtworksWhenFiltersAreCleared();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/active_filters_buttons/list.vue?6910a70e